export const RouteConstants = {
  // auth routes (local-auth, served by public-fuel-ms — not auth-ms)
  SIGN_IN_ROUTE: "/auth/v2/login",
  SIGN_UP_ROUTE: "/auth/v2/register",
  OTP_REQUEST: "/auth/v2/otp/request",
  OTP_VERIFY: "/auth/v2/otp/verify",
  PASSWORD_RESET_REQUEST: "/auth/v2/password/reset-request",
  REFRESH_TOKEN: "/auth/v2/refresh",
  LOGOUT: "/auth/v2/logout",
  ME: "/auth/v2/me",
  MY_PROFILE: "/me/profile",

  //fuel routes
  ALL_STATS: "/me/stats",
  MY_PENDING_COUPONS: "/me/unpaid-coupons",
  MY_AVAILABLE_PAID_COUPONS: "/me/paid-available-coupons",
  MY_ARCHIVED_COUPONS: "/me/archived-coupons",
  UNARCHIVE_COUPONS: "/unarchive-coupons",
  ARCHIVE_COUPONS: "/archive-coupons",
  MY_DISCOUNT_COUPONS: "/me/discounts",
  MY_DISCOUNT_STATS: "/me/discount-stats",
  MY_OTHER_COUPONS: "/me/others-coupons",
  MY_USED_COUPONS: "/me/used-coupons",
  MY_COUPONS: "/me/coupons",
  MY_COUPON_EVENTS: "/me/coupon-events",
  COUPONS_ROUTE: "/coupons",
  MERGE_COUPONS: "/merge-coupons",
  WALLET_ROUTE: "/me/wallets",
  ALL_REGIONS: "/regions",
  ALL_SUPPORTED_REGIONS: "/supported-regions",
  MY_PENDING_PAYMENT_COUPONS: "/me/both-stats",
  MY_OTHER_STATS: "/me/others-stats",
};
